// extracted by mini-css-extract-plugin
export default {"wrap":"Register_wrap__ctDv2","formWraper":"Register_formWraper__YlfMo","formItem":"Register_formItem__Dr9yv"};